import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $cardStore } from '@lib/store';
import { PaletteUtils } from '@shared/utils';
import { Button, Modal, Text } from '@shared/widgets';

interface ActivateModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ActivateModal = (props: ActivateModalProps) => {
  const cardStore = useUnit($cardStore.store);

  const { t } = useTranslation('card');

  const activateHandler = async () => {
    await $cardStore.events.activate(cardStore.data!.cardId);
    props.onClose();
  };

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} title={t('sidebar.modals.activate.title')} width='332px'>
      {PaletteUtils.isVcfcPalette ? (
        <Text className='text-center' weight='medium'>
          {t('sidebar.modals.activate.descriptionVcfc')}
        </Text>
      ) : (
        <Text
          weight='medium'
          dangerouslySetInnerHTML={{
            __html: t('sidebar.modals.activate.description', {
              cardHolder: cardStore.data?.cardHolder || '',
              lastDigits: cardStore.data?.cardNumber?.slice(-4) || '',
            }),
          }}
        />
      )}
      <div className='mt-6 flex gap-3'>
        <Button fullWidth color='outlined' onClick={props.onClose}>
          {t('buttons.close', { ns: 'common' })}
        </Button>
        <Button fullWidth color='primary' onClick={activateHandler}>
          {t('sidebar.modals.activate.buttons.activate')}
        </Button>
      </div>
    </Modal>
  );
};
